var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-template page-wrapper"},[_c('OrganismsOrganismMenuBarEmbedProject',[(_vm.i18nActive)?_c('AtomsCommonAtomLocaleSwitch',{staticClass:"locale-switch"}):_vm._e()],1),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('LazyOrganismsOrganismModals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }